
// const idTokenResult = await user.getIdTokenResult();
// if (!idTokenResult.claims.tenantId) {
//     console.error("No tenant ID associated with user.");
//     return Promise.reject();
// }


import React from 'react';
import { Box, Typography } from '@mui/material';

const Dashboard = () => {
    return (
        <Box sx={{ padding: 3 }}>
            <Typography variant="h4" gutterBottom>
                Dashboard
            </Typography>
            <Typography>
                Welcome to the standalone Dashboard page. This page is outside the main layout.
            </Typography>
        </Box>
    );
};

export default Dashboard;











// import React, { useEffect, useState } from 'react';
// import { auth } from '../firebase';
// import { getFirestore, doc, getDoc } from 'firebase/firestore';

// const Dashboard = () => {
//     const [userData, setUserData] = useState<any>(null);
//     const [error, setError] = useState<string>('');
//     const [isNewUser, setIsNewUser] = useState<boolean>(false);

//     useEffect(() => {
//         const unsubscribe = auth.onAuthStateChanged(async (user) => {
//             if (user) {
//                 const db = getFirestore();
//                 const userDocRef = doc(db, 'users', user.uid);
//                 const userDoc = await getDoc(userDocRef);
//                 if (userDoc.exists()) {
//                     setUserData(userDoc.data());
//                     // Check if tenantId or other user data is missing to determine if it's a new user
//                     if (!userDoc.data().tenantId) {
//                         setIsNewUser(true);
//                     }
//                 } else {
//                     setError('No such user found!');
//                 }
//             } else {
//                 setError('User is not authenticated');
//             }
//         });

//         return () => unsubscribe();
//     }, []);

//     if (error) {
//         return <div>{error}</div>;
//     }

//     return (
//         <div>
//             <h1>Dashboard</h1>
//             {userData ? (
//                 <div>
//                     {isNewUser && <h2>Hello, new user!</h2>}  {/* Show this message for new users */}
//                     <h2>Tenant ID: {userData.tenantId}</h2>
//                     <p>Welcome, {userData.email}</p>
//                 </div>
//             ) : (
//                 <p>Loading user data...</p>
//             )}
//         </div>
//     );
// };

// export default Dashboard;
